import React, { useEffect, useState } from 'react';
import { Container, Heading, Text, Button, Flex, Box } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';
import { InfoCircledIcon } from '@radix-ui/react-icons';
import './PaymentCancel.css';

const PaymentCancel = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);

  useEffect(() => {
    // Log for debugging
    console.log('PaymentCancel component mounted. Redirecting to home in 15 seconds.');
    
    // Auto-redirect to landing page after 15 seconds
    const redirectTimer = setTimeout(() => {
      navigate('/');
    }, 15000);

    // Countdown timer
    const countdownInterval = setInterval(() => {
      setCountdown(prevCount => {
        if (prevCount <= 1) {
          clearInterval(countdownInterval);
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    // Clean up the timers when component unmounts
    return () => {
      clearTimeout(redirectTimer);
      clearInterval(countdownInterval);
    };
  }, [navigate]);

  return (
    <div style={{ backgroundColor: '#fff5f5', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Container size="2" className="payment-cancel-container">
        <Flex 
          direction="column" 
          align="center" 
          justify="center" 
          style={{ textAlign: 'center' }}
        >
          <div style={{ 
            backgroundColor: 'rgba(255, 99, 71, 0.2)', 
            borderRadius: '50%', 
            width: '100px', 
            height: '100px', 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            marginBottom: '1.5rem'
          }}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#ff4d4f" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <Heading 
            size="8" 
            style={{ 
              color: '#f5222d',
              marginBottom: '1.5rem'
            }}
          >
            Payment Cancelled
          </Heading>
          
          <Text 
            size="3" 
            style={{ 
              color: '#3e3e3e',
              marginBottom: '1.5rem'
            }}
          >
            Your payment has been cancelled. No charges were made.
          </Text>

          <Box 
            style={{ 
              padding: '0.75rem 1rem',
              background: 'rgba(0, 0, 0, 0.05)',
              borderRadius: '8px',
              marginBottom: '2rem',
              maxWidth: '90%'
            }}
          >
            <Flex align="center" justify="center" gap="2">
              <InfoCircledIcon color="#616161" width={16} height={16} />
              <Text size="2" style={{ color: '#616161' }}>
                You can try again anytime or contact support if you need assistance.
              </Text>
            </Flex>
          </Box>

          <Text size="2" style={{ color: '#666', marginBottom: '1.5rem' }}>
            You'll be redirected to the home page automatically in <span style={{ fontWeight: 'bold' }}>{countdown}</span> seconds.
          </Text>
          
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Button 
              variant="outline"
              onClick={() => navigate('/')}
              style={{
                padding: '0 2rem',
                height: '40px',
                width: '180px',
                border: '1px solid #d9d9d9',
                borderRadius: '4px',
                backgroundColor: 'white',
                color: '#262626',
                fontSize: '14px',
                fontWeight: 500,
                cursor: 'pointer'
              }}
            >
              Return to Home
            </Button>
          </div>
        </Flex>
      </Container>
    </div>
  );
};

export default PaymentCancel; 